import { Tab } from '../../../../../../views/team/reports';

export default {
  tabs: {
    [Tab.General]: 'Geral',
    [Tab.SignedLive]: 'Assinados / Ativos',
    [Tab.MRR]: 'MRR',
    [Tab.CollectedCommission]: 'Comissão',
  },
};
